var React = require('react');

function UserIconGreenInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.7","cx":"12.5","cy":"12.5","r":"12.5","fill":"#DCFFEC","key":0}),React.createElement("path",{"d":"M15.1284 13.4737C15.6961 13.4737 16.1562 13.9647 16.1562 14.5703V15.0181C16.1562 15.2976 16.0743 15.5702 15.922 15.7977C15.2154 16.8524 14.0617 17.375 12.4985 17.375C10.935 17.375 9.78185 16.8522 9.07701 15.7969C8.92529 15.5697 8.84375 15.2978 8.84375 15.0188V14.5703C8.84375 13.9647 9.30393 13.4737 9.87159 13.4737H15.1284ZM12.4985 7.62498C13.7606 7.62498 14.7837 8.71648 14.7837 10.0629C14.7837 11.4094 13.7606 12.5009 12.4985 12.5009C11.2364 12.5009 10.2133 11.4094 10.2133 10.0629C10.2133 8.71648 11.2364 7.62498 12.4985 7.62498Z","fill":"#48D38A","key":1})]);
}

UserIconGreenInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = UserIconGreenInline;

UserIconGreenInline.default = UserIconGreenInline;
